<template>
  <div class="Background">

    <div style="display: flex;justify-content: space-between">
      <div class="link_location">
        <h2 class="mb-5">
          {{ $store.getters.t('통계') }}
          <v-icon class="mdi mdi-chevron-right" />
          <span style="color: rgb(29, 120, 211); font-weight: bold;">{{ $store.getters.t('VOD 전체 통계') }}</span>
          
        </h2>
      </div>
      <div ref="datePickerContainer">
        <v-text-field
          ref="dateField"
          v-model="dateRangeText"
          :placeholder="$store.getters.t ? $store.getters.t('시작일-종료일 선택') : '시작일-종료일 선택'"
          prepend-inner-icon="mdi-calendar"
          readonly
          @focus="isDatePickerVisible = true"
          outlined
          style="background: #ffffff;"
          dense />

          <v-date-picker
          v-model="dates"
          range
          v-if="isDatePickerVisible"
          @input="onDateChange"
          full-width
          class="data_picker"
          color="#006cea"
          />
      </div>
    </div>


    <v-row>
      <v-col>
        <v-card class="pa-5" elevation="0" height="440px">
          <h2 style="display: flex;height: 48px;align-items: center;margin-bottom: 24px;">{{ $store.getters.t('트래픽') }}</h2>

          <!-- tencent traffic-->
          <TencentTrafficComponent :formattedDate="dateRangeText" :reference="reference" :units="units" />
        </v-card>
      </v-col>
      <v-col class="ml-5 mr-5">
        <v-card class="pa-5" elevation="0" height="440px">
          <h2 style="display: flex;height: 48px;align-items: center;margin-bottom: 24px;">{{ $store.getters.t('스토리지') }}</h2>

          <!--스토리지-->
          <StorageComponent :reference="reference" :units="units" />
        </v-card>
      </v-col>
      <v-col>
        <v-card class="pa-5" elevation="0" height="440px">
          <h2 style="display: flex;height: 48px;align-items: center;margin-bottom: 24px;">{{ $store.getters.t('인코딩') }}</h2>

          <!--인코딩-->
          <EncodingComponent :formattedDate="dateRangeText" :reference="reference" :units="units" />
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-5">

      <v-col md="6" sm="12">
        <v-card class="pa-5 mr-3" elevation="0">
          <v-row>
            <v-col cols="9">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <div style="display: flex;">
                  <h2>{{ $store.getters.t('Traffic Trend (Daily)') }}</h2>
                  <h4 class="sub_title">{{ $store.getters.t('CDN Usage') }}</h4>
                </div>
              </div>
            </v-col>
            <v-col class="text-right">
              <v-btn icon :color="trafficDailyUnit === 'M' ? '#006cea' : 'grey'" outlined small style="font-size: 10px;"
              @click="changeTrafficDailyUnit('M')">MB</v-btn>
            <v-btn icon :color="trafficDailyUnit === 'G' ? '#006cea' : 'grey'" outlined small style="font-size: 10px;"
              @click="changeTrafficDailyUnit('G')" class="ml-1 mr-1">GB</v-btn>
            <v-btn icon :color="trafficDailyUnit === 'T' ? '#006cea' : 'grey'" outlined small style="font-size: 10px;"
              @click="changeTrafficDailyUnit('T')">TB</v-btn>
            </v-col>
          </v-row>
          <h5 v-if="this.startTime" class="mt-3" style="color: #bbb"><b style="color: #006cea;">{{ $store.getters.t('총합') }} </b> {{ this.dailyTotal }} {{ trafficDailyUnit }}</h5>
          <DailyTraffic class="mt-5" :daily-data="dailyData" :trafficDailyUnit="trafficDailyUnit" />
          <v-row>
            <v-col class="text-right">
              <span class="mb-2" style="color:#bbb;font-size: 12px;" v-if="this.startTime">
                {{ $store.getters.t('기간') }}: {{ this.startTime }} ~ {{ this.endTime }}
              </span>
            </v-col>
          </v-row>
          
        </v-card>
      </v-col>


      <v-col md="6" sm="12">
        <v-card class="pa-5 ml-2" elevation="0">
          <v-row>
            <v-col cols="9">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <div style="display: flex;">
                  <h2>{{ $store.getters.t('Traffic Trend (Monthly)') }}</h2>
                  <h4 class="sub_title">{{ $store.getters.t('CDN Usage') }}</h4>
                </div>
              </div>
            </v-col>
            <v-col class="text-right">
              <v-btn icon :color="trafficUnitMonthly === 'M' ? '#006cea' : 'grey'" outlined small style="font-size: 10px;"
                @click="changeTrafficMonthlyUnit('M')">MB</v-btn>
              <v-btn icon :color="trafficUnitMonthly === 'G' ? '#006cea' : 'grey'" outlined small style="font-size: 10px;"
                @click="changeTrafficMonthlyUnit('G')" class="ml-1 mr-1">GB</v-btn>
              <v-btn icon :color="trafficUnitMonthly === 'T' ? '#006cea' : 'grey'" outlined small style="font-size: 10px;"
                @click="changeTrafficMonthlyUnit('T')">TB</v-btn>
            </v-col>
          </v-row>
          
          
          <h5 v-if="this.startTimeMonthly" class="mt-3" style="color: #bbb"><b style="color: #006cea;">{{ $store.getters.t('총합') }} </b>{{ this.monthlyTotal }} {{ trafficUnitMonthly }}</h5>
          <MonthlTyraffic class="mt-5" :monthly-data="monthlyData" :trafficUnitMonthly="trafficUnitMonthly" />
          <v-row>
            <v-col class="text-right">
              <span class="mb-2" style="color:#bbb;font-size: 12px;" v-if="this.startTimeMonthly">
                {{ $store.getters.t('기간') }}: {{ this.startTimeMonthly }} ~ {{ this.endTimeMonthly }}
              </span>
            </v-col>
          </v-row>

        </v-card>
      </v-col>

    </v-row>

    <!--end-->
  </div>





</template>

<script>
import DailyTraffic from '@/components/statistics/allStatistics/DailyTraffic.vue';
import MonthlTyraffic from '@/components/statistics/allStatistics/MonthlTyraffic.vue';
import TencentTrafficComponent from '@/components/statistics/allStatistics/TencentTrafficComponent.vue';
import StorageComponent from '@/components/statistics/allStatistics/StorageComponent.vue';
import EncodingComponent from '@/components/statistics/allStatistics/EncodingComponent.vue';
import StatisticsApi from "@/api/statistics/StatisticsApi";


export default {
  components: {
    TencentTrafficComponent,
    StorageComponent,
    EncodingComponent,
    DailyTraffic,
    MonthlTyraffic,

  },
  async created(){
    await this.getServiceStart();
  },
  async beforeMount() {
    try {
      await this.get_RP();
    } catch (error) {
      console.error('error:', error);
    }
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  mounted() {
    if(sessionStorage.getItem('AccessToken') == null) return;

    this.getTencentTrafficDailyUsageData();
    this.getTencentTrafficMonthlyUsageData();
    document.addEventListener("click", this.handleClickOutside);
  },
  computed: {
    // formattedDate() {
    //     const date = new Date(); 
    //     var year = date.getFullYear();
    //     var month = String(date.getMonth() + 1).padStart(2, '0'); 
    //     var day = String(date.getDate()).padStart(2, '0'); 

    //     date.setMonth(date.getMonth() - 1);
    //     const year1 = date.getFullYear();
    //     const month1 = String(date.getMonth() + 1).padStart(2, '0'); 
    //     const day1 = String(date.getDate()).padStart(2, '0'); 

    //     const formattedDate01 = `${year1}-${month1}-${day1}`;
    //     const formattedDate = `${year}-${month}-${day}`;
    //     this.startDate = formattedDate01;
    //     this.endDate = formattedDate;


    //     if (this.dates.length === 2) {
    //         var start = this.dates[0];
    //         var end = this.dates[1];

    //         if (start && end && start > end) {
    //             const tmp = end;
    //             end = start;
    //             start = tmp;
    //         }

    //         this.dateRangeText =  `${start} ~ ${end}`;
    //     }
    //     this.dateRangeText = `${formattedDate01} ~ ${formattedDate}`;

    //     // console.log("dateRangeText => ", this.dateRangeText)

    //     return this.dateRangeText;
    // },

    dateRangeText: {
        get(){
            const date = new Date(); 
            var year = date.getFullYear();
            var month = String(date.getMonth() + 1).padStart(2, '0'); 
            var day = String(date.getDate()).padStart(2, '0'); 

            date.setMonth(date.getMonth() - 1);
            const year1 = date.getFullYear();
            const month1 = String(date.getMonth() + 1).padStart(2, '0'); 
            const day1 = String(date.getDate()).padStart(2, '0'); 

            const formattedDate01 = `${year1}-${month1}-${day1}`;
            const formattedDate = `${year}-${month}-${day}`;
            this.startDate = formattedDate01;
            this.endDate = formattedDate;

            if (this.dates.length === 2) {
                var start = this.dates[0];
                var end = this.dates[1];

                if (start && end && start > end) {
                    const tmp = end;
                    end = start;
                    start = tmp;
                }
                
                return `${start} ~ ${end}`;
            }
            return `${formattedDate01} ~ ${formattedDate}`;
        },
        set(){

        }
    },


  },
  data() {
    return {
      reference: {
        rp_traffic: 0,
        rp_encoding: 0,
        rp_storage: 0,
        rp_unit: ''
      },
      unit: 'G',
      trafficDailyUnit: 'G',
      dailyData: [],
      startTime: '',
      endTime: '',
      dailyTotal: '',
      monthlyData: [],
      monthlyTotal: '',
      endTimeMonthly: '',
      startTimeMonthly: '',
      trafficUnitMonthly: 'G',
      units: 'G',
      dates: [],
      isDatePickerVisible: false,
      updateCheck: false,
      startDate: '',
      endDate: '',

    };
  },
  methods: {
     formattedDate(start, end) {
      return `${start} ~ ${end}`;
    },
    async getServiceStart(){
      const startService = await StatisticsApi.startService();
      // console.log("확인 => ", startService)
      
      this.startDate = startService['start'];
      this.endDate = startService['end'];

      this.dates = [this.startDate, this.endDate];
      this.dateRangeText = this.formattedDate(this.startDate, this.endDate);

    },
    handleClickOutside(event) {
      if (this.$refs.datePickerContainer && !this.$refs.datePickerContainer.contains(event.target)) {
        this.isDatePickerVisible = false;
      }
    },
    onDateChange(newDates) {
        if (newDates.start && newDates.end && newDates.start > newDates.end) {
            this.dates.end = this.dates.start;
        } else {
            this.dates = newDates;
        }

        if (this.dates.length === 2) {
            // this.startDate = this.dates[0];
            // this.endDate = this.dates[1];

            // if (this.startDate && this.endDate && this.startDate > this.endDate) {
            //     const tmp = this.endDate;
            //     this.endDate = this.startDate;
            //     this.startDate = tmp;
            // }
            // this.dateRangeText = `${this.formatDate(this.startDate)} - ${this.formatDate(this.endDate)}`;
            // this.isDatePickerVisible = false;

            // this.updateCheck = true;
            let [start, end] = this.dates;
            if (start > end) {
              [start, end] = [end, start];
            }
            this.startDate = start;
            this.endDate = end;
            this.dateRangeText = this.formattedDate(start, end);
            this.isDatePickerVisible = false;
            this.updateCheck = true;
        }
    },
    formatDate(date) {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}/${month}/${day}`;
    },
    async get_RP() {
      try {
        const response = await StatisticsApi.getRpApi();

        if (response != null) {
          this.rp_traffic = response['rp_traffic'];
          this.unit_traffic = response['unit'];

          
          if (Object.keys(response).length === 0) {
            this.reference = {
              'rp_traffic': '1000',
              'rp_encoding': '1000',
              'rp_storage': '1000',
              'rp_unit': 'GB'
            };
          } else {
            this.reference = {
              'rp_traffic': response['rp_traffic'],
              'rp_encoding': response['rp_encoding'],
              'rp_storage': response['rp_storage'],
              'rp_unit': response['rp_unit']
            };
          }

          this.units = this.reference.rp_unit;
        }
      } catch (error) {
        console.log("[get_RP error]", error);
      }
    },
    async getTencentTrafficDailyUsageData() {
      const response = await StatisticsApi.tencentTrafficDailyApi();
      if(response){
        if (response.status === 0) {
          this.startTime = response.date.start_time;
          this.endTime = response.date.end_time;
          this.dailyData = [];
        }
        this.startTime = response.date.start_time;
        this.endTime = response.date.end_time;
        this.dailyData = response.chartData;

        const unit = 'G';
        this.calculateTotalSum(unit);
      }
    },
    changeTrafficDailyUnit(unit) {
      this.trafficDailyUnit = unit;
    },
    calculateTotalSum(unit) {
      let result = this.dailyData.reduce((acc, item) => acc + item.Sum, 0);
      switch (unit) {
        case 'M':
          result *= 1000;
          break;
        case 'G':
          result;
          break;
        case 'T':
          result /= 1000;
          break;
        default:
          break;
      }
      this.dailyTotal = result.toFixed(2);
    },
    async getTencentTrafficMonthlyUsageData() {
      const response = await StatisticsApi.tencentTrafficMonthlyApi();
      if(response){
        if (response.status === 0) {
          this.startTimeMonthly = response.date.start_time;
          this.endTimeMonthly = response.date.end_time;
          this.monthlyData = [];
        }
        this.startTimeMonthly = response.date.start_time;
        this.endTimeMonthly = response.date.end_time;
        this.monthlyData = response.chartData;

        const unit = 'G';
        this.calculateTotalMonthSum(unit);
      }
    },

    changeTrafficMonthlyUnit(unit) {
      this.trafficUnitMonthly = unit;
    },
    calculateTotalMonthSum(unit) {
      let result = this.monthlyData.reduce((acc, item) => acc + item.Sum, 0);
      switch (unit) {
        case 'M':
          result *= 1000;
          break;
        case 'G':
          result;
          break;
        case 'T':
          result /= 1000;
          break;
        default:
          break;
      }
      this.monthlyTotal = result.toFixed(2);
    },
  },
  watch: {
    trafficDailyUnit(newUnit, oldUnit) {
      if (newUnit !== oldUnit) {
        this.calculateTotalSum(newUnit);
      }
    },
    trafficUnitMonthly(newUnit, oldUnit) {
      if (newUnit !== oldUnit) {
        this.calculateTotalMonthSum(newUnit);
      }
    },
  },


}
</script>

<style lang="scss" scoped>
.v-sheet.v-snack__wrapper {
  border-radius: 2px;
}

.red_error {
  border-top: 3px solid #F24545;
}

.sub_title {
  width: auto;
  height: 50%;
  background: #edf5ff;
  padding: 6px 10px 6px;
  border-radius: 4px;
  color: #006cea;
  margin-left: 12px;
}

.data_picker { 
    width: 234px;
    z-index: 99;
    position: absolute;
}

.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot, .v-text-field.v-text-field--enclosed .v-text-field__details {
    width: 234px !important;
}
.v-input__control {
    align-items: end !important;
}
.theme--light.v-input {
    height: 40px !important;
}
.v-text-field input {
    font-size: 14px;
}

</style>